import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClientSummaryComponent } from './client-summary/client-summary.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientDetailComponent } from './client-detail/client-detail.component';
import { ClientFilesComponent } from './client-files/client-files.component';
import { ClientDocumentComponent } from './client-document/client-document.component';
import { ClientContactComponent } from './client-contact/client-contact.component';
import { ClientFinancialsComponent } from './client-financials/client-financials.component';
import { ClientResolver } from 'src/app/shared/resolvers/clients.resolver';
import { ServiceResolver } from 'src/app/shared/resolvers/services.resolver';
import { CreateNewClientComponent } from './create-new-client/create-new-client.component';
import { ClientBankDetailsComponent } from './client-bank-details/client-bank-details.component';
import { ClientContractsComponent } from './client-contracts/client-contracts.component';
import { ClientPartnersComponent } from './client-partners/client-partners.component';
import { FinancialGuard } from 'src/app/core/guards/financial.guard';



const routes: Routes = [
  {
    path: '',
    component: ClientsComponent,
  },
  {
    path: 'new',
    component: CreateNewClientComponent,
    resolve: { services: ServiceResolver },
  },
  {
    path: ':id',
    component: ClientDetailComponent,
    resolve: { client: ClientResolver },
    children: [
      { path: '', redirectTo: 'summary', pathMatch: 'full' },
      {
        path: 'summary',
        component: ClientSummaryComponent,
        resolve: { services: ServiceResolver }
      },
      {
        path: 'files',
        component: ClientFilesComponent
      },
      {
        path: 'documents',
        component: ClientDocumentComponent
      },
      {
        path: 'contact',
        component: ClientContactComponent
      },
      {
        path: 'bank-accounts',
        component: ClientBankDetailsComponent
      },
      {
        path: 'financials',
        component: ClientFinancialsComponent
      },
      {
        path: 'contracts',
        component: ClientContractsComponent,
        resolve: { services: ServiceResolver },
        canActivate: [FinancialGuard]
      },
      {
        path: 'partners',
        component: ClientPartnersComponent
      }
    ]
  }  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClientsRoutingModule { }
